import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../global-service/global-service';
import { Subject } from 'rxjs';

/*
  Generated class for the IxomM2xProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class IxomM2xProvider {
  collectionSubject = new Subject<any>();
  bssURL: String = this.globalServiceProvider.appConfig.bss_api;
  ixomsSchedule: Array<any> = [];
  constructor(public http: HttpClient, public globalServiceProvider: GlobalServiceProvider) {
    console.log('Hello IxomM2xProvider Provider');
  }

  publishCollection(data: any) {
    this.collectionSubject.next(data);
  }
  getObservable(): Subject<any> {
    return this.collectionSubject;
  }
  
  async getIxomM2XJobByDriver(date: string, custCode: string, isSiteAcc: any, SoldTo: any, ShipTo: any) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.get<any[]>(`${this.bssURL}/ixom/dashboard?date=${date}&custCode=${custCode}&isSiteAcc=${isSiteAcc}&SoldTo=${SoldTo}&ShipTo=${ShipTo}`).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  getSchedule(startDate: string, endDate: string, custCode: string, isSiteAcc: any, SoldTo: any, ShipTo: any) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.get<any[]>(`${this.bssURL}/ixom/schedule`,
      { params: { startDate: startDate, endDate: endDate, custCode: custCode, isSiteAcc: isSiteAcc, SoldTo: SoldTo, ShipTo: ShipTo } }
      ).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  async vehicleCurrentLocation(vehicle: string) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.get<any[]>(`${this.bssURL}/ixom/vehicle/${vehicle}`).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  async getPOD(id: string, data: any) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.put<any[]>(`${this.bssURL}/ixom/pod/` + id, data).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  async getATD(id: string, data: any) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.put<any[]>(`${this.bssURL}/ixom/atd/` + id, data).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  async getDVSR(id: string, data: any) {
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.put<any[]>(`${this.bssURL}/ixom/dvsr/` + id, data).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  async getIXOMHistory(filter: any, condition: any, custCode: string, isSiteAcc: any, SoldTo: any, ShipTo: any) {
    const options: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'json',
      params: {
        filter: JSON.stringify(filter),
        condition: JSON.stringify(condition),
        data: JSON.stringify({
          custCode: custCode,
          isSiteAcc: isSiteAcc,
          SoldTo: SoldTo, 
          ShipTo: ShipTo
        })
      }
    };
    return new Promise<any[]>((resolve: any, reject: any) => {
      this.http.get<any[]>(`${this.bssURL}/ixom/history`, options).subscribe((result: any) => {
        console.log('ixom: ', result);
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/ixom-m2x/ixom-m2x.ts